import React, { useState, useEffect } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { toast } from 'react-toastify';

/**
 * Grid <-> Floor Plan switch for the /dashboard home screen. Shared between the Header's profile
 * dropdown and the footer so both stay in sync — each instance listens for `layoutModeChanged` so
 * flipping one updates the other immediately instead of only updating on next mount.
 */
const LayoutModeToggle = ({ id = 'layoutModeToggle', className = 'form-check form-switch mb-0' }) => {
  const [floorPlanViewEnabled, setFloorPlanViewEnabled] = useState(
    (localStorage.getItem('layout_mode') || 'grid') === 'floor_plan'
  );

  useEffect(() => {
    const onLayoutModeChanged = () => {
      setFloorPlanViewEnabled((localStorage.getItem('layout_mode') || 'grid') === 'floor_plan');
    };
    window.addEventListener('layoutModeChanged', onLayoutModeChanged);
    return () => window.removeEventListener('layoutModeChanged', onLayoutModeChanged);
  }, []);

  const handleLayoutModeToggle = async (e) => {
    const newMode = e.target.checked ? 'floor_plan' : 'grid';
    setFloorPlanViewEnabled(e.target.checked);
    try {
      await callAPI(apiUrls.UPDATE_LAYOUT_MODE, {}, 'POST', { layout_mode: newMode }, {});
      localStorage.setItem('layout_mode', newMode);
      window.dispatchEvent(new Event('layoutModeChanged'));
      toast.success(newMode === 'floor_plan' ? 'Floor Plan view enabled' : 'Grid view enabled');
    } catch (err) {
      setFloorPlanViewEnabled(!e.target.checked);
      toast.error('Failed to update layout preference');
    }
  };

  return (
    <div className={className} onClick={(e) => e.stopPropagation()}>
      <input
        className="form-check-input"
        type="checkbox"
        id={id}
        checked={floorPlanViewEnabled}
        onChange={handleLayoutModeToggle}
      />
      <label className="form-check-label" htmlFor={id}>
        Floor Plan View
      </label>
    </div>
  );
};

export default LayoutModeToggle;
